import React, { useEffect, Component } from 'react';

import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { Grid, Typography, CircularProgress } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive'
import { Card } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import FadeIn from 'react-fade-in';

import { getCompanyData } from './API/Company';

import { Mobile, NotMobile, getRemotePolicyText, getRemotePolicyDateRange, getCompanyScore  } from '../../utils';
import StarWidgetReadOnly from '../../Components/StarWidgetReadOnly';

import GridLoader from '../../img/grid-loader.svg'
import InfoIcon from '../../img/info.svg'

const styles = (theme) => ({
    root: {},
    ticker: {
        minHeight: "140px",
        width: "210px",
        padding: "13px",
        textAlign: "center",
        cursor: "pointer",
        fontFamily: "Lato",
        '&:hover': {
            backgroundColor: "#d3d3d38f"
        }
    },
    loadingTicker: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    tickerContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        maxWidth: "100%",
        position: "relative"
    },
    tickerPolicy: {
        marginTop: "9px",
        fontSize: "14px",
        fontFamily: "Lato"
    },
    logo: {
        height: "40px",
        marginBottom: "7px",
        marginTop: "3px"
    },
    metadata: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: "12px",
        marginTop: "5px",
        marginBottom: "-7px"
    },
    benefits: {
        display: "flex",
        alignItems: "center"
    },
    gridLoader: {
        width: "40px"
    },
    infoIcon: {
        width: "14px",
        position: "relative",
        top: "2px",
        left: "4px"
    },
    '@media (max-width: 767px)': {
        tickerContainer: {
            flexDirection: "column",
            margin: "auto"
        },
        wrapper: {
            margin: "5px 0",
        }
    }
});

const SmallerScreen = ({ children }) => {
    const isSmaller = useMediaQuery({ maxWidth: 1199 });
    return isSmaller ? children : null;
}

const LargerScreen = ({ children }) => {
    const isLarger = useMediaQuery({ minWidth: 1200 })
    return isLarger ? children : null;
}

class Tickers extends Component {

    constructor() {
        super();
        this.lists = [
            { 
                title: "Featured",
                list: [
                    "Google",
                    "Apple",
                    "PayPal",                     
                    "Amazon",                   
                    "Twitter"
                ]
            },
            { 
                title: "Recently Updated",
                list: [
                    "Amazon",
                    "Paypal",
                    "Twitter",
                    "Google",
                    "Apple"                    
                ]
            },            
        ]

        this.state = { 
            data: [], 
            loading: true,
            open: false,
            slide: 0,
        }
    }

    getTickerData = async () => {
        let data = [];
        const list = this.lists[this.state.slide].list;

        data = await Promise.all(
            list.map(async (item, index) => {
                return await getCompanyData(item)
            })
        );

        this.setState({ data, loading: false });
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { data, loading } = this.state;
        if ((data === [] && nextState.data !== []) || (loading === true && nextState.loading === false)) {
            return true;
        }
        return false;
    }


    render() {

        const { classes, toggleDialog } = this.props;
        const { data, loading } = this.state;

        if (loading) {
            this.getTickerData();
        }

        const Ticker = React.memo(function TickerA({ company, toggleDialog }) {
            let history = useHistory();     

            if (!company) {
                return (
                    <div className={classes.wrapper}>
                        <NotMobile>
                            <FadeIn>
                                <Card raised className={`${classes.ticker} ${classes.loadingTicker}`}>
                                    <img src={GridLoader} className={classes.gridLoader} alt="loading" />
                                </Card>                               
                            </FadeIn>
                        </NotMobile>
                        <Mobile>
                            <FadeIn>
                                <Card variant="outlined" className={`${classes.ticker} ${classes.loadingTicker}`}>
                                    <img src={GridLoader} className={classes.gridLoader} alt="loading" />
                                </Card>
                            </FadeIn>
                        </Mobile>
                    </div>
                )
            }

            const { companyName: name, reviews: { details } } = company;
            const iconSrc = company.metadata.companyData.icon.logo;
            const policy = getRemotePolicyText(company.remotePolicy);
            const range = getRemotePolicyDateRange(company);
            const reviewsText = details.length ? `${details.length} Reviews` : 'No Reviews';
            const avgScore = getCompanyScore(company);
       
            const goToDetailPage = () => history.push(`/company/${name}`);

            return (
                <div className={classes.wrapper} onClick={goToDetailPage}>
                    <NotMobile>
                        <Card raised className={classes.ticker}>
                            <FadeIn>
                                <div>
                                    <img src={iconSrc} className={classes.logo} alt="" />
                                </div>
                                <b>{name}</b>
                                <div className={classes.tickerPolicy}>
                                    <b>{policy}</b><img src={InfoIcon} onClick={toggleDialog} className={classes.infoIcon} /><br/>
                                    <i style={{ fontSize: "12px" }}>{range}</i>
                                </div>
                                <div className={classes.metadata}>
                                    <div className={classes.reviews}>
                                        <StarWidgetReadOnly rating={avgScore} />
                                    </div>
                                    <div className={classes.benefits}>
                                        {reviewsText}
                                    </div>
                                </div>
                            </FadeIn>
                        </Card>  
                    </NotMobile>
                    <Mobile>
                        <Card variant="outlined" className={classes.ticker}>
                            <FadeIn>
                                <div>
                                    <img src={iconSrc} className={classes.logo} alt="" />
                                </div>
                                <b>{name}</b>
                                <div className={classes.tickerPolicy}>
                                    <b>{policy}</b><img src={InfoIcon} onClick={toggleDialog} className={classes.infoIcon} /><br/>
                                    <i style={{ fontSize: "12px" }}>{range}</i>
                                </div>
                                <div className={classes.metadata}>
                                    <div className={classes.reviews}>
                                        <StarWidgetReadOnly rating={avgScore} />
                                    </div>
                                    <div className={classes.benefits}>
                                        {reviewsText}
                                    </div>
                                </div>                                
                            </FadeIn>
                        </Card>
                    </Mobile>
                </div>
            )
        })

        const getDesktopTickers = () => {
            if (data.length) {
                return data.map((co) => <Ticker key={co.companyName} company={co} toggleDialog={toggleDialog} />)
            }
            return this.lists[this.state.slide].list.map(() => <Ticker />);
        }

        const getMobileTickers = () => {
            let res = [];

            for(let i = 0; i < 3; i++) {
                if (data[i] && data[i].companyName) {
                    res.push(<Ticker key={data[i].companyName} company={data[i]} toggleDialog={toggleDialog} />);
                }
                else {
                    res.push(<Ticker /> )
                }
            }

            return res;
        }

        return (
            <div className={classes.tickerContainer}>
                <SmallerScreen>
                    {getMobileTickers()}
                </SmallerScreen>
                <LargerScreen>
                    {getDesktopTickers()}
                </LargerScreen>
            </div>
        )
    }
}

export default withStyles(styles)(Tickers);
